import { get, post } from '@/redux/requests/api.js';

export const getPieveUserActivation = () => {
  return get('/v1/pieve/user-activation', {
    action: 'GET_PIEVE_USER_ACTIVATION',
    loader: 'getPieveUserActivation'
  });
};

export const generatePieveUserActivation = ({ name = '', job = '', jobFamily = '', isDevRole = null } = {}) => {
  return post('/v1/pieve/user-activation/generate', {
    action: 'GENERATE_PIEVE_USER_ACTIVATION',
    loader: 'generatePieveUserActivation',
    data: { name, job, jobFamily, isDevRole }
  });
};

export const dismissPieveUserActivation = () => {
  return post('/v1/pieve/user-activation/dismiss', {
    action: 'DISMISS_PIEVE_USER_ACTIVATION',
    loader: 'dismissPieveUserActivation',
    data: {}
  });
};

export const acceptPieveUserActivation = () => {
  return post('/v1/pieve/user-activation/accept', {
    action: 'ACCEPT_PIEVE_USER_ACTIVATION',
    loader: 'acceptPieveUserActivation',
    data: {}
  });
};

export const createPieveUserActivationAnalyticsDestination = () => {
  return post('/v1/pieve/user-activation/analytics-destination', {
    loader: 'createPieveUserActivationAnalyticsDestination',
    data: {}
  });
};
